var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPenIconDisabled(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 12C0 5.37258 5.37258 0 12 0V0C18.6274 0 24 5.37258 24 12V12C24 18.6274 18.6274 24 12 24V24C5.37258 24 0 18.6274 0 12V12Z",
    fill: "#CED5DD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.1716 6.87868C19.5621 7.26921 19.5621 7.90237 19.1716 8.2929L8.29289 19.1716C8.10535 19.3591 7.851 19.4645 7.58578 19.4645L5 19.4645C4.44771 19.4645 4 19.0168 4 18.4645L4 15.8787C4 15.6135 4.10535 15.3591 4.29289 15.1716L15.1716 4.2929C15.5621 3.90237 16.1953 3.90237 16.5858 4.2929L19.1716 6.87868ZM14.7574 9.87864L7.17157 17.4645L6 17.4645L6 16.2929L13.5858 8.70706L14.7574 9.87864ZM16.1716 8.46442L15 7.29285L15.8787 6.41422L17.0503 7.58579L16.1716 8.46442Z",
    fill: "#95A5B6"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPenIconDisabled);
export default __webpack_public_path__ + "static/media/pen-icon-disabled.e051758b51161bd9247cbff775b33d92.svg";
export { ForwardRef as ReactComponent };